const ManuallyInputtedTransactionRefStatus = require('@/lib/Payments/ManuallyInputtedTransactionRefStatus');
const TransactionRefState = require('@/libraries/DigiTickets/Payment/TransactionRefState');
/**
 * Directive to enable the transactionRef field in a payment modal. This is a way of capturing a transactionRef
 * for non integrated payment methods which will help reduce reconciliation problems and tie DigiTickets payments to
 * their real world payment or voucher equivalents. The field can be 'unsupported' in which case it won't show at all,
 * 'optional' or 'required'.
 *
 * The directive is designed to be very simple to setup for a payment method but still requires a bit of setup:
 *
 * 1. Set 'Supports Manually Inputted Transaction Ref' for the payment method in 'backoffice' to either 'optional' or
 *    required. If this is set to 'unsupported' the directive will not show.
 *
 * 2. Update the payment method template and include the directive e.g.
 *    <dt-transaction-ref transaction-ref="transactionRef" ng-hide="!showTransactionRef"></dt-transaction-ref>
 *
 * 3. If the payment method has it's own Controller you will need to:
 *    a. Add $scope.transactionRef = null;
 *    b. Add $scope.transactionRefIsValid = true;
 *    c. If this is using numPad set the option: doNotCaptureKeysIn: ['.transaction-ref input']
 *    d. Add the ref to the payment e.g. payment.setTransactionRef($scope.transactionRef);
 *
 * @param {PaymentMethodService} paymentMethodService
 */
const transactionRefDirective = function (paymentMethodService) {
    return {
        restrict: 'E',
        templateUrl: 'partials/directives/dt-transaction-ref.html',
        controller: function ($scope) {
            const paymentMethod = paymentMethodService.getByRef($scope.$parent.paymentMethod.ref);
            const transactionRefStatus = paymentMethod.manuallyInputtedTransactionRefStatus;

            $scope.isRequired = false;
            $scope.langKey = 'PAYMENT.TRANSACTION_REF_OPTIONAL';

            // Should we show the field in the payment modal?
            $scope.$parent.showTransactionRef = false;

            // Is the transactionRef valid? (An empty transactionRef is valid if it isn't required).
            $scope.transactionRefIsValid = true;

            if (transactionRefStatus !== ManuallyInputtedTransactionRefStatus.UNSUPPORTED) {
                $scope.$parent.showTransactionRef = true;
                if (transactionRefStatus === ManuallyInputtedTransactionRefStatus.REQUIRED) {
                    $scope.isRequired = true;
                    $scope.transactionRefIsValid = false;
                    $scope.langKey = 'PAYMENT.TRANSACTION_REF_REQUIRED';
                }
            }

            // Called when the data in the actual directive input field changes.
            $scope.validateTransactionRef = function () {
                if ($scope.isRequired) {
                    if ($scope.transactionRef && $scope.transactionRef.trim()) {
                        $scope.transactionRefIsValid = true;
                        $scope.transactionRef = $scope.transactionRef.trim();
                    } else {
                        $scope.transactionRefIsValid = false;
                    }
                }

                $scope.setTransactionRefState(
                    new TransactionRefState(
                        paymentMethod,
                        $scope.transactionRef,
                        $scope.transactionRefIsValid
                    )
                );
            };

            // Call when the directive is initialised.
            $scope.validateTransactionRef();

            // For example to clear the transactionRef field on the main payment method view when the partial payment
            // modal on the same screen is used to add a payment.
            $scope.$on('payment-modal.clear-transaction-ref', (event, selectedPaymentMethod) => {
                if (paymentMethod.ref === selectedPaymentMethod.ref) {
                    $scope.transactionRef = null;
                }
            });
        },
    };
};

module.exports = transactionRefDirective;
